function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M1,4h17.2c0.5,1.6,2.2,2.4,3.8,1.8c0.9-0.3,1.5-1,1.8-1.8H27c0.6,0,1-0.4,1-1s-0.4-1-1-1h-3.2c-0.5-1.6-2.2-2.4-3.8-1.8 c-0.9,0.3-1.5,1-1.8,1.8H1C0.4,2,0,2.4,0,3S0.4,4,1,4z M21,2c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1C20,2.4,20.4,2,21,2z"
}), React.createElement("path", {
  d: "M27,10H9.8C9.3,8.5,7.6,7.6,6,8.2c-0.9,0.3-1.5,1-1.8,1.8H1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h3.2c0.5,1.6,2.2,2.4,3.8,1.8 c0.9-0.3,1.5-1,1.8-1.8H27c0.6,0,1-0.4,1-1C28,10.5,27.6,10,27,10z M7,12c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1s1,0.4,1,1 C8,11.6,7.6,12,7,12z"
}), React.createElement("path", {
  d: "M27,18h-3.2c-0.5-1.6-2.2-2.4-3.8-1.8c-0.9,0.3-1.5,1-1.8,1.8H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h17.2c0.5,1.6,2.2,2.4,3.8,1.8 c0.9-0.3,1.5-1,1.8-1.8H27c0.6,0,1-0.4,1-1S27.6,18,27,18z M21,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1C22,19.6,21.6,20,21,20z"
}));

var SvgSettingsIcon = function SvgSettingsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "28px",
    height: "22.1px",
    viewBox: "0 0 28 22.1",
    style: {
      enableBackground: "new 0 0 28 22.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSettingsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settingsIcon.34ea8d08.svg";
export { ForwardRef as ReactComponent };